// Profile.js
import React from "react";
import LocationTable from "./LocationTable";

const Location = () => {
  return (
    <div style={profileStyle}>
      <LocationTable/>
    </div>
  );
};

const profileStyle = {
  // width:"90%",
  background:"#fff",
  borderRadius:"8px",
  marginInline:"16px",
  marginTop:"20px",
  padding:"20px"
};

export default Location;
